package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.em

@Page("exposed")
@Composable
fun ExposedBackendPage() {
    Column(
        horizontalAlignment = Alignment.Start,
        modifier = Modifier.fillMaxSize().padding(leftRight = 0.1.em),
    ) {
        KotlinCode(
            code = """
                    @OptIn(ExperimentalDatabaseMigrationApi::class)
                    fun Application.configureDatabase() {
                        
                        Database.connect(
                            "jdbc:postgresql://localhost:5432/postgres",
                            driver = "org.postgresql.Driver",
                            user = "postgres",
                            password = "kamal+123"
                        )

                        transaction {

                            val tables = arrayOf(
                                UsersTable
                            )

                            SchemaUtils.run {
                                create(*tables)
                                addMissingColumnsStatements(*tables)
                            }

                            MigrationUtils.run {
                                val dir = File("./migrations/")
                                if (!dir.exists())
                                    dir.mkdir()

                                generateMigrationScript(
                                    *tables,
                                    scriptDirectory = "./migrations/",
                                    scriptName = "migration"
                                )
                                dropUnmappedIndices(*tables)
                                dropUnmappedSequences(*tables)
                            }
                        }
                    }
                    """.trimIndent()
        )

        KotlinCode(
            code = """
                    abstract class ExtUUIDTable(name: String, columnName: String = "id") : UUIDTable(name, columnName) {
                        val isActive = bool("is_active").default(true)
                        val createdAt = timestamp("created_at").clientDefault { Instant.now() }
                        val modifiedAt = timestamp("modified_at").clientDefault { Instant.now() }
                    }
                    
                    object UsersTable : ExtUUIDTable("users", "user_id") {
                        val userName = varchar("user_name", 256)
                        val userPassword = varchar("user_password", 256).nullable()
                        val userEmail = varchar("user_email", 256).uniqueIndex()
                        val mustChangePassword = bool("must_change_password").default(false)
                        val userBigProfilePicture = binary("user_big_profile_picture").nullable()
                        val userSmallProfilePicture = binary("user_small_profile_picture").nullable()
                        val lastActivity = timestamp("last_activity").clientDefault { Instant.now() }
                        val userBio = text("user_bio").default("")
                        val userCountryCode = varchar("user_country_code", 2).default("")
                        val userTown = varchar("user_town", 256).default("")
                    }
                    
                    //reference
                    object QuizzesTable : ExtUUIDTable("quizzes", "quiz_id") {
                        val quizCreator = reference("user_id", UsersTable)

                        val quizName = varchar("quiz_name", 255)
                        val quizDescription = text("quiz_description")
                        val quizImage = binary("quiz_image").nullable()
                        val visibility = integer("visibility").default(0)
                        val likesCount = integer("likes_count").default(0)
                    }
                    """.trimIndent()
        )
    }
}
